/* global analyticsLib */

// =============================================================================
// step 1
// =============================================================================

const currentURL = window.location.href;
const env = currentURL.startsWith('https://www') ? 'Prod' : 'Dev';

export function loadStep1() {
  window['analyticsData'] = {
    event: 'custom_view', //E1
    params: {
      view_name: 'QueProductosTenesPrestamoConsumo',
      action: 'Contratar',
      area: 'NaoLogado',
      business: 'PF',
      channel: 'SitioPublico',
      country: 'UY',
      environment: env,
      family: 'Prestamo',
      subfamily: 'CreditoConsumo',
      techspec_id: 'g3z6xwget4y5entsbqgoro',
    },
    toolkit: {
      versao: '2.0',
    },
  };

  if (typeof analyticsLib === 'undefined') return;
  if (typeof window?.analyticsLib === 'undefined') return;
  if (typeof analyticsLib.trackAction !== 'function') return;
  if (typeof window.analyticsLib.trackAction !== 'function') return;

  analyticsLib.trackAction({
    ComponentClicked: '|AC:null|TP:null|ID:null|PO:null|MO:null',
  });
}

export function customInteraction_step1() {
  window['analyticsData'] = {
    event: 'custom_interaction', //E2
    params: {
      interaction_action: 'Click',
      interaction_type: 'Button',
      interaction_description: 'TenesTareja|{{Si/No}}(QueProductosTenesPrestamoConsumo)',
      action: 'Contratar',
      area: 'NaoLogado',
      business: 'PF',
      channel: 'SitioPublico',
      country: 'UY',
      environment: env,
      family: 'Prestamo',
      subfamily: 'CreditoConsumo',
      techspec_id: 'g3z6xwget4y5entsbqgoro',
    },
    toolkit: {
      versao: '2.0',
    },
  };

  if (typeof analyticsLib === 'undefined') return;
  if (typeof window?.analyticsLib === 'undefined') return;
  if (typeof analyticsLib.trackAction !== 'function') return;
  if (typeof window.analyticsLib.trackAction !== 'function') return;

  analyticsLib.trackAction({
    ComponentClicked: '|AC:null|TP:null|ID:null|PO:null|MO:null',
  });
}

export function nextStep_step1() {
  window['analyticsData'] = {
    event: 'custom_interaction', //E3
    params: {
      interaction_action: 'Click',
      interaction_type: 'Button',
      interaction_description: 'Siguiente|{{tipo_cuenta}}(QueProductosTenesPrestamoConsumo)',
      action: 'Contratar',
      area: 'NaoLogado',
      business: 'PF',
      channel: 'SitioPublico',
      country: 'UY',
      environment: env,
      family: 'Prestamo',
      subfamily: 'CreditoConsumo',
      techspec_id: 'g3z6xwget4y5entsbqgoro',
    },
    toolkit: {
      versao: '2.0',
    },
  };

  if (typeof analyticsLib === 'undefined') return;
  if (typeof window?.analyticsLib === 'undefined') return;
  if (typeof analyticsLib.trackAction !== 'function') return;
  if (typeof window.analyticsLib.trackAction !== 'function') return;

  analyticsLib.trackAction({
    ComponentClicked: '|AC:null|TP:null|ID:null|PO:null|MO:null',
  });
}

// =============================================================================
// step 2
// =============================================================================

export function loadStep2() {
  window['analyticsData'] = {
    event: 'custom_view', //E1
    params: {
      view_name: 'ElegiPrestamoConsumo',
      action: 'Contratar',
      area: 'NaoLogado',
      business: 'PF',
      channel: 'SitioPublico',
      country: 'UY',
      environment: env,
      family: 'Prestamo',
      subfamily: 'CreditoConsumo',
      techspec_id: 'g3z6xwget4y5entsbqgoro',
    },
    toolkit: {
      versao: '2.0',
    },
  };

  if (typeof analyticsLib === 'undefined') return;
  if (typeof window?.analyticsLib === 'undefined') return;
  if (typeof analyticsLib.trackAction !== 'function') return;
  if (typeof window.analyticsLib.trackAction !== 'function') return;

  analyticsLib.trackAction({
    ComponentClicked: '|AC:null|TP:null|ID:null|PO:null|MO:null',
  });
}

export function amortizable_step2() {
  window['analyticsData'] = {
    event: 'custom_interaction', //E2
    params: {
      interaction_action: 'Click',
      interaction_type: 'Button',
      interaction_description: 'VerMasAmortizable(ElegiPrestamoConsumo)',
      action: 'Contratar',
      area: 'NaoLogado',
      business: 'PF',
      channel: 'SitioPublico',
      country: 'UY',
      environment: env,
      family: 'Prestamo',
      subfamily: 'CreditoConsumo',
      techspec_id: 'g3z6xwget4y5entsbqgoro',
    },
    toolkit: {
      versao: '2.0',
    },
  };

  if (typeof analyticsLib === 'undefined') return;
  if (typeof window?.analyticsLib === 'undefined') return;
  if (typeof analyticsLib.trackAction !== 'function') return;
  if (typeof window.analyticsLib.trackAction !== 'function') return;

  analyticsLib.trackAction({
    ComponentClicked: '|AC:null|TP:null|ID:null|PO:null|MO:null',
  });
}

export function tc_step2() {
  window['analyticsData'] = {
    event: 'custom_interaction', //E3
    params: {
      interaction_action: 'Click',
      interaction_type: 'Button',
      interaction_description: 'VerMasPrestamoTarjeta(ElegiPrestamoConsumo)',
      action: 'Contratar',
      area: 'NaoLogado',
      business: 'PF',
      channel: 'SitioPublico',
      country: 'UY',
      environment: env,
      family: 'Prestamo',
      subfamily: 'CreditoConsumo',
      techspec_id: 'g3z6xwget4y5entsbqgoro',
    },
    toolkit: {
      versao: '2.0',
    },
  };

  if (typeof analyticsLib === 'undefined') return;
  if (typeof window?.analyticsLib === 'undefined') return;
  if (typeof analyticsLib.trackAction !== 'function') return;
  if (typeof window.analyticsLib.trackAction !== 'function') return;

  analyticsLib.trackAction({
    ComponentClicked: '|AC:null|TP:null|ID:null|PO:null|MO:null',
  });
}

export function sobregiro_step2() {
  window['analyticsData'] = {
    event: 'custom_interaction', //E4
    params: {
      interaction_action: 'Click',
      interaction_type: 'Button',
      interaction_description: 'VerMasSobregiro(ElegiPrestamoConsumo)',
      action: 'Contratar',
      area: 'NaoLogado',
      business: 'PF',
      channel: 'SitioPublico',
      country: 'UY',
      environment: env,
      family: 'Prestamo',
      subfamily: 'CreditoConsumo',
      techspec_id: 'g3z6xwget4y5entsbqgoro',
    },
    toolkit: {
      versao: '2.0',
    },
  };

  if (typeof analyticsLib === 'undefined') return;
  if (typeof window?.analyticsLib === 'undefined') return;
  if (typeof analyticsLib.trackAction !== 'function') return;
  if (typeof window.analyticsLib.trackAction !== 'function') return;

  analyticsLib.trackAction({
    ComponentClicked: '|AC:null|TP:null|ID:null|PO:null|MO:null',
  });
}

export function nextStep_step2() {
  window['analyticsData'] = {
    event: 'custom_interaction', //E5
    params: {
      interaction_action: 'Click',
      interaction_type: 'Button',
      interaction_description: 'LoQuieroYa(ElegiPrestamoConsumo)',
      action: 'Contratar',
      area: 'NaoLogado',
      business: 'PF',
      channel: 'SitioPublico',
      country: 'UY',
      environment: env,
      family: 'Prestamo',
      subfamily: 'CreditoConsumo',
      techspec_id: 'g3z6xwget4y5entsbqgoro',
    },
    toolkit: {
      versao: '2.0',
    },
  };

  if (typeof analyticsLib === 'undefined') return;
  if (typeof window?.analyticsLib === 'undefined') return;
  if (typeof analyticsLib.trackAction !== 'function') return;
  if (typeof window.analyticsLib.trackAction !== 'function') return;

  analyticsLib.trackAction({
    ComponentClicked: '|AC:null|TP:null|ID:null|PO:null|MO:null',
  });
}

// =============================================================================
// login
// =============================================================================

export function loginModal() {
  window['analyticsData'] = {
    event: 'custom_view', //E1
    params: {
      view_name: 'LoginSitioPublico',
      action: 'Loguear',
      area: 'NaoLogado',
      business: 'PF',
      channel: 'SitioPublico',
      country: 'UY',
      environment: env,
      family: 'Login',
      subfamily: 'Login',
      techspec_id: 'g3z6xwget4y5entsbqgoro',
    },
    toolkit: {
      versao: '2.0',
    },
  };

  if (typeof analyticsLib === 'undefined') return;
  if (typeof window?.analyticsLib === 'undefined') return;
  if (typeof analyticsLib.trackAction !== 'function') return;
  if (typeof window.analyticsLib.trackAction !== 'function') return;

  analyticsLib.trackAction({
    ComponentClicked: '|AC:null|TP:null|ID:null|PO:null|MO:null',
  });
}

export function loginClick() {
  window['analyticsData'] = {
    event: 'custom_interaction', //E2
    params: {
      interaction_action: 'Click',
      interaction_type: 'Button',
      interaction_description: 'Ingresar(LoginSitioPublico)',
      action: 'Loguear',
      area: 'NaoLogado',
      business: 'PF',
      channel: 'SitioPublico',
      country: 'UY',
      environment: env,
      family: 'Login',
      subfamily: 'Login',
      techspec_id: 'g3z6xwget4y5entsbqgoro',
    },
    toolkit: {
      versao: '2.0',
    },
  };

  if (typeof analyticsLib === 'undefined') return;
  if (typeof window?.analyticsLib === 'undefined') return;
  if (typeof analyticsLib.trackAction !== 'function') return;
  if (typeof window.analyticsLib.trackAction !== 'function') return;

  analyticsLib.trackAction({
    ComponentClicked: '|AC:null|TP:null|ID:null|PO:null|MO:null',
  });
}
